import { createSelector } from 'reselect';
import enums from '../../../constants/enums';

export const getPayments = (state) => state.payments.payments;
export const getTypeTotals = (state) => state.payments.typeTotals;

export const getTypes = createSelector(
  getTypeTotals,
  (typeTotals)=>{
    const totalsMap = {};
    typeTotals.forEach(total=>{
      totalsMap[total._id] = total.total;
    });
    let giftcards = enums.giftcards
      .filter(card=>{
        return typeof totalsMap[card.value] === 'undefined';
      })
      .sort();

    typeTotals.forEach(total=>{
      giftcards.unshift({
        value: total._id,
      });
    });

    return giftcards
      .map(giftcard=> ({
        label: `${giftcard.value} - ${(totalsMap[giftcard.value] || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD'})}`,
        value: giftcard.value,
      }));
  }
);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/Payments.selectors.js